import { render, staticRenderFns } from "./specialty.vue?vue&type=template&id=6345fbd7&"
import script from "./specialty.vue?vue&type=script&lang=ts&"
export * from "./specialty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports